(function () {
  'use strict';
  // --- Pure decisions (node tests: scripts/tests/so-cart-speed.test.cjs in the smoke-organic repo) ---
  var PRE_YES = 'Yes — ships once all items in stock';
  // The Preorder cart attribute value to WRITE, or null when the cart already holds it. `current` is the
  // attribute as last known (cart JSON, the Liquid-rendered data-current-preorder, or our own last write);
  // undefined/null = unknown → write, as before. Task 26: stops the /cart/update.js on every quantity tap.
  function preorderWrite(hasPre, current) {
    var want = hasPre ? PRE_YES : '';
    if (current == null) return want;
    return String(current) === want ? null : want;
  }
  // A cart JSON (from the theme's on:line-item:change detail, or our /cart.js) is reused instead of a fresh
  // /cart.js read while it is younger than this — the event and the re-rendered element arrive together —
  // AND it describes exactly the lines on screen (same line keys, same quantities). Anything else (an add,
  // a Change swap, a reduce that fired no event with a cart) reads /cart.js as before.
  var FRESH_MS = 1500;
  function freshCart(shared, now, lines) {
    var c = shared && shared.cart;
    if (!c || !Array.isArray(c.items) || !(now - shared.at < FRESH_MS) || !Array.isArray(lines)) return null;
    if (c.items.length !== lines.length) return null;
    for (var i = 0; i < lines.length; i++) {
      var it = null;
      for (var j = 0; j < c.items.length; j++) if (c.items[j].key === lines[i].key) { it = c.items[j]; break; }
      if (!it || it.quantity !== lines[i].qty) return null;
    }
    return c;
  }
  // The Preorder attribute a cart JSON tells us, or undefined when it can't be trusted: no attributes, or one of
  // our own writes is still in flight (that JSON was read before the write landed).
  function preorderFromCart(c, writing) {
    if (writing > 0 || !c || !c.attributes || typeof c.attributes !== 'object') return undefined;
    return c.attributes.Preorder || '';
  }
  var pure = { preorderWrite: preorderWrite, freshCart: freshCart, preorderFromCart: preorderFromCart, PRE_YES: PRE_YES, FRESH_MS: FRESH_MS };
  if (typeof module === 'object' && module.exports) module.exports = pure;
  if (typeof window === 'undefined' || typeof customElements === 'undefined') return;
  if (customElements.get('so-preorder-cart')) return;

  // Shared by every instance (the theme re-renders the cart footer — and this element — on each change):
  // the freshest cart JSON the page has and the Preorder attribute as last known. One capture listener,
  // attached once, so it runs before any instance reacts to the same event.
  // `writing`: our /cart/update.js calls in flight. A cart JSON that arrives meanwhile (the change event fires
  // right after the re-render that triggered the write) was read BEFORE that write, so its attributes are
  // ignored until the write's own response says what the cart holds.
  var shared = { cart: null, at: 0, preorder: undefined, writing: 0 };
  function takeCart(c) {
    if (!c || !Array.isArray(c.items)) return;
    shared.cart = c; shared.at = Date.now();
    var v = preorderFromCart(c, shared.writing);
    if (v !== undefined) shared.preorder = v;
  }
  document.addEventListener('on:line-item:change', function (e) { takeCart(e.detail && e.detail.cart); }, true);

  // One document-level delegated handler for per-line "reduce to N" buttons, attached once.
  if (!window.__soPreorderReduceBound) {
    window.__soPreorderReduceBound = true;
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-so-reduce]');
      if (!btn) return;
      e.preventDefault();
      const qty = Number(btn.getAttribute('data-so-stock-now'));
      const idx = btn.getAttribute('data-so-index');
      const container = btn.closest('cart-items, #cart-items, .cart-items') || document;
      // Drive the theme's native quantity input so the cart re-renders IN PLACE (no full reload).
      const input = container.querySelector('input[name="updates[]"][data-index="' + idx + '"]');
      if (input) {
        btn.disabled = true;
        input.value = String(qty);
        input.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      // Fallback: AJAX change + reload if the native input can't be found.
      const key = btn.getAttribute('data-so-line-key');
      btn.disabled = true;
      try {
        await fetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty }),
        });
        window.location.reload();
      } catch (err) { btn.disabled = false; }
    });
  }

  let soInstanceSeq = 0;

  class SoPreorderCart extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('.cart-drawer__checkout-buttons, .cart__checkout-buttons') || this.parentElement || document;
      this.choice = this.querySelector('.so-preorder-cart__choice');
      this.ack = this.querySelector('.so-preorder-cart__ack');
      this.checkbox = this.querySelector('.so-preorder-cart__checkbox');
      this.preview = this.querySelector('.so-preorder-cart__preview');
      this.unavailableMsg = this.querySelector('[data-so-unavailable-msg]');
      this.packminMsg = this.querySelector('[data-so-packmin-msg]');
      this.radios = Array.from(this.querySelectorAll('.so-preorder-cart__radio'));
      this.summaryEl = this.querySelector('.so-preorder-cart__summary');
      this.optsEl = this.querySelector('.so-preorder-cart__opts');
      this.summaryText = this.querySelector('.so-preorder-cart__summary-text');
      this.changeBtn = this.querySelector('.so-preorder-cart__change');
      this.leadTime = this.dataset.leadTime || '5–10 business days';
      this.expanded = true; // radios shown until a choice is made
      // F2/R3: the ack text is a plain attribute (no live <so-ship> element can hydrate inside it), so
      // swap its "(~leadTime)" fragment for the dated compact range computed here, at connect time.
      this.querySelector('.so-preorder-cart__ack-text').textContent = this.preShipAckText();
      const gname = 'so-preorder-choice-' + (++soInstanceSeq);
      this.radios.forEach((r) => (r.name = gname));
      this.cart = null;

      // The Preorder attribute as the server rendered it (Task 26): render() writes it only on a real change.
      if (shared.preorder === undefined && this.hasAttribute('data-current-preorder')) shared.preorder = this.getAttribute('data-current-preorder');

      if (!this._bound) {   // element-local listeners: once per element (they go with it when it is replaced)
        this._bound = true;
        this.checkbox.addEventListener('change', () => { this.saveChoice(); this.applyGate(); });
        this.radios.forEach((r) => r.addEventListener('change', () => this.onRadio()));
        if (this.changeBtn) this.changeBtn.addEventListener('click', () => { this.expanded = true; this.render(); });
      }
      // Intercept checkout so "Remove" only commits (trims the cart) at the moment of checkout.
      this._onScopeClick = (e) => { if (e.target.closest('[name="checkout"]')) this.onCheckoutClick(e); };
      this.scope.addEventListener('click', this._onScopeClick, true);

      // Task 26: ONE live listener set + observer per connected element, removed in disconnectedCallback.
      // (Every cart change re-renders this element; each old instance used to keep its observer and
      // document listeners, so tap n fired n+1 /cart.js reads.)
      this._dead = false;
      this._debounce = null;
      this._schedule = () => { clearTimeout(this._debounce); this._debounce = setTimeout(() => this.refresh(), 120); };
      this._events = ['cart:refresh', 'on:cart:change', 'cart:updated', 'on:cart:add'];
      this._events.forEach((ev) => document.addEventListener(ev, this._schedule));
      const items = document.querySelector('cart-items, #cart-items, .cart-items');
      if (items) { this._mo = new MutationObserver(this._schedule); this._mo.observe(items, { childList: true, subtree: true }); }

      this.render();   // instant visibility/gate
      this._schedule(); // prices: the cart JSON that came with this re-render (no request), else /cart.js
    }

    disconnectedCallback() {
      clearTimeout(this._debounce);
      if (this._mo) { this._mo.disconnect(); this._mo = null; }
      if (this._events) this._events.forEach((ev) => document.removeEventListener(ev, this._schedule));
      if (this.scope && this._onScopeClick) this.scope.removeEventListener('click', this._onScopeClick, true);
      this._dead = true;
    }

    lineData() { return Array.from(document.querySelectorAll('.so-preorder-line-data')); }
    // Bundles are never pre-orderable: a bundle line with an out-of-stock component is UNAVAILABLE
    // and must be removed before checkout (also guards the case where a component sold out after the
    // bundle was added — Shopify's checkout won't block a continue-selling component).
    hasUnavailableBundle() { return !!document.querySelector('.so-preorder-line-data[data-so-bundle-unavailable]'); }
    // A pack-min pre-order line must be a positive whole-pack multiple. Uses live /cart.js quantities.
    hasInvalidPackLine() {
      if (!this.cart) return false;
      return this.lineData().some((el) => {
        const size = Number(el.getAttribute('data-so-pack-size')) || 0;
        if (size < 2) return false;
        const item = this.cart.items.find((i) => i.key === el.getAttribute('data-so-line-key'));
        if (!item) return false;
        return item.quantity < size || item.quantity % size !== 0;
      });
    }
    // Floor + step the cart line quantity inputs for pack-min lines (UX; the gate is the hard rule).
    applyPackInputs() {
      this.lineData().forEach((el) => {
        const size = Number(el.getAttribute('data-so-pack-size')) || 0;
        const idx = el.getAttribute('data-so-index');
        if (size < 2 || !idx) return;
        const input = document.querySelector('input[name="updates[]"][data-index="' + idx + '"]');
        if (input) { input.min = String(size); input.step = String(size); }
      });
    }
    totals() {
      let pre = 0, shipnow = 0;
      this.lineData().forEach((el) => {
        pre += Number(el.getAttribute('data-so-preorder-units')) || 0;
        shipnow += Number(el.getAttribute('data-so-shipnow-units')) || 0;
      });
      return { pre, shipnow };
    }
    // Total (cents) of only the in-stock units, using authoritative per-unit prices from /cart.js.
    reducedCents() {
      if (!this.cart) return null;
      let cents = 0;
      this.lineData().forEach((el) => {
        const key = el.getAttribute('data-so-line-key');
        const ship = Number(el.getAttribute('data-so-shipnow-units')) || 0;
        const item = this.cart.items.find((i) => i.key === key);
        if (item) cents += item.final_price * ship;
      });
      return cents;
    }
    checkoutBtns() { return Array.from(this.scope.querySelectorAll('[name="checkout"]')); }
    acceleratedEls() { return Array.from(this.scope.querySelectorAll('.dynamic-cart-btns, [data-shopify-buttoncontainer]')); }
    moneyTextNode(el) {
      const w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      let n;
      while ((n = w.nextNode())) { if (/[\d,]+\.\d{2}/.test(n.nodeValue)) return n; }
      return null;
    }
    selectedRadio() { return this.radios.find((r) => r.checked); }
    isRemoveSelected() {
      const { pre, shipnow } = this.totals();
      const sel = this.selectedRadio();
      return pre > 0 && shipnow > 0 && !!sel && sel.value === 'shipnow';
    }
    // Writes the Preorder cart attribute only when it differs from what the cart holds (Task 26).
    async setAttr(on) {
      const value = preorderWrite(on, shared.preorder);
      if (value == null) return;
      const prev = shared.preorder;
      shared.preorder = value;   // claimed now, so a sibling re-render in the meantime doesn't write it again
      shared.writing++;
      let known = prev;
      try {
        const r = await fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { Preorder: value } }),
        });
        if (r.ok) {
          known = value;
          const c = await r.json().catch(() => null);   // the cart as it is now, after this write
          if (c && c.attributes && typeof c.attributes === 'object') known = c.attributes.Preorder || '';
        }
      } catch (e) { /* non-blocking */ }
      shared.writing--;
      if (shared.preorder === value) shared.preorder = known;   // unless a newer write claimed it meanwhile
    }
    // Preview only — swap the checkout-button price text + show a note. No cart mutation.
    showPreview() {
      const cents = this.reducedCents();
      if (cents == null) return;
      const amt = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      this.checkoutBtns().forEach((btn) => {
        const node = this.moneyTextNode(btn);
        if (node) { if (node.__soOrig == null) node.__soOrig = node.nodeValue; node.nodeValue = node.__soOrig.replace(/[\d,]+\.\d{2}/, amt); }
      });
      if (this.preview) { this.preview.hidden = false; this.preview.textContent = "You'll pay R " + amt + ' now — the pre-order items are removed at checkout.'; }
    }
    clearPreview() {
      this.checkoutBtns().forEach((btn) => {
        const node = this.moneyTextNode(btn);
        if (node && node.__soOrig != null) node.nodeValue = node.__soOrig;
      });
      if (this.preview) this.preview.hidden = true;
    }
    updateOptClasses() {
      this.radios.forEach((r) => {
        const opt = r.closest('.so-preorder-cart__opt');
        if (opt) opt.classList.toggle('is-selected', r.checked);
      });
    }
    // A radio pick collapses the cards to the summary.
    onRadio() { this.expanded = false; this.saveChoice(); this.updateOptClasses(); this.render(); }
    // --- Remembering the decision ---------------------------------------------------------------
    // The theme re-renders the cart footer (and this element) on every cart change, which used to
    // wipe the Keep/Remove pick (or the fully-pre-order tick) and ask again. The decision is kept in
    // sessionStorage with the pre-order items it covered; it is restored while the pre-order items
    // in the cart are a subset of those. A NEW pre-order item (not yet decided on) asks again.
    preIds() {
      const ids = [];
      this.lineData().forEach((el) => {
        if ((Number(el.getAttribute('data-so-preorder-units')) || 0) > 0) {
          const id = String(el.getAttribute('data-so-line-key') || '').split(':')[0];
          if (id && ids.indexOf(id) === -1) ids.push(id);
        }
      });
      return ids;
    }
    saveChoice() {
      const { shipnow } = this.totals();
      const sel = this.selectedRadio();
      const choice = shipnow > 0 ? (sel ? sel.value : null) : (this.checkbox.checked ? 'ack' : null);
      try {
        if (!choice) sessionStorage.removeItem('soPreorderChoice');
        else sessionStorage.setItem('soPreorderChoice', JSON.stringify({ choice, ids: this.preIds() }));
      } catch (e) { /* storage blocked: falls back to asking again */ }
    }
    restoreChoice(hasPre, mixed) {
      if (!hasPre) return;
      let saved = null;
      try { saved = JSON.parse(sessionStorage.getItem('soPreorderChoice') || 'null'); } catch (e) { saved = null; }
      if (!saved || !Array.isArray(saved.ids)) return;
      const covered = this.preIds().every((id) => saved.ids.indexOf(id) !== -1);
      if (!covered) return; // a new pre-order item: ask again
      if (mixed) {
        if (this.selectedRadio()) return;
        const r = this.radios.find((x) => x.value === saved.choice);
        if (r) {
          r.checked = true; this.expanded = false; this.updateOptClasses();
          // Tell the delivery row and the add-ons notes (they switch figures on this radio's change),
          // exactly as a tap would — after this render pass, so the re-rendered footer is in place.
          setTimeout(() => { if (r.isConnected && r.checked) r.dispatchEvent(new Event('change', { bubbles: true })); }, 0);
        }
      } else if (saved.choice === 'ack' && !this.checkbox.checked) {
        this.checkbox.checked = true;
      }
    }
    // R3: bare dated ship phrase ("around 5 – 12 Oct" / fallback "in 5–10 business days" — no leading
    // "ships ", since every caller here already supplies its own verb), null when SO.stock
    // (assets/so-stock-state.js) hasn't loaded.
    preShipBare() {
      return (window.SO && window.SO.stock) ? window.SO.stock.shipText('pre', null, null, true, true) : null;
    }
    // "(around 5 – 12 Oct)" for the acknowledgement checkbox label; falls back to the Liquid-rendered
    // "(~leadTime)" text unchanged when SO.stock is unavailable.
    preShipAckText() {
      var ship = this.preShipBare();
      if (!ship) return this.dataset.ackText;
      return this.dataset.ackText.replace(/\(~[^)]*\)/, '(' + ship + ')');
    }
    // Summary text shown in the collapsed state.
    updateSummary(mixed) {
      if (!this.summaryText || !mixed) return;
      if (this.isRemoveSelected()) { this.summaryText.textContent = 'Pre-order items removed at checkout.'; return; }
      var ship = this.preShipBare();
      this.summaryText.textContent = ship
        ? 'Includes pre-order — ships together, ' + ship + '.'
        : 'Includes pre-order — ships together in ~' + this.leadTime + '.';
    }
    onCheckoutClick(e) {
      if (this.isRemoveSelected()) { e.preventDefault(); e.stopPropagation(); this.commitRemoveThenCheckout(); }
      // Otherwise (Keep, or fully-preorder acknowledgement) proceed normally to checkout.
    }
    // Commit the removal, then go straight to checkout (only fired from the checkout click).
    async commitRemoveThenCheckout() {
      const updates = {};
      this.lineData().forEach((el) => {
        if ((Number(el.getAttribute('data-so-preorder-units')) || 0) > 0) {
          const key = el.getAttribute('data-so-line-key');
          if (key) updates[key] = Number(el.getAttribute('data-so-stock-now')) || 0;
        }
      });
      try {
        await fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates, attributes: { Preorder: '' } }),
        });
        window.location.href = '/checkout';
      } catch (e) { window.location.href = '/cart'; }
    }
    acknowledged() {
      const { shipnow } = this.totals();
      if (shipnow > 0) return !!this.selectedRadio();   // mixed: either choice is a valid decision
      return this.checkbox.checked;                      // fully preorder: must tick
    }
    // Prices for the preview / pack gate: the cart JSON the theme's change event carried (no request) when
    // fresh, else /cart.js (Task 26).
    async refresh() {
      if (this._dead) return;
      const seen = {};   // the /cart page also has the drawer's copy of each line: one entry per line key
      const lines = [];
      this.lineData().forEach((el) => {
        const key = el.getAttribute('data-so-line-key');
        if (seen[key]) return;
        seen[key] = true;
        lines.push({ key, qty: (Number(el.getAttribute('data-so-preorder-units')) || 0) + (Number(el.getAttribute('data-so-shipnow-units')) || 0) });
      });
      const fresh = freshCart(shared, Date.now(), lines);
      if (fresh) { this.cart = fresh; this.render(); return; }
      try { const c = await (await fetch('/cart.js')).json(); takeCart(c); this.cart = c; } catch (e) { /* keep last */ }
      if (!this._dead) this.render();
    }
    render() {
      const { pre, shipnow } = this.totals();
      const hasPre = pre > 0;
      const mixed = hasPre && shipnow > 0;
      this.restoreChoice(hasPre, mixed);
      const unavailable = this.hasUnavailableBundle();
      this.applyPackInputs();
      if (this.choice) this.choice.hidden = !mixed;
      if (this.ack) this.ack.hidden = !(hasPre && !mixed);
      this.acceleratedEls().forEach((el) => (el.style.display = hasPre || unavailable ? 'none' : ''));
      if (hasPre !== this._lastPre) { this.setAttr(hasPre); this._lastPre = hasPre; }   // setAttr skips a no-op write
      if (!hasPre) { this.checkbox.checked = false; this.radios.forEach((r) => (r.checked = false)); this.expanded = true; }
      // Show the radio cards until a choice is made; once chosen, collapse to a summary
      // (re-openable via "Change"). No default — checkout waits for an explicit pick.
      const hasSel = !!this.selectedRadio();
      const showOpts = mixed && (!hasSel || this.expanded);
      if (this.summaryEl) this.summaryEl.hidden = !mixed || showOpts;
      if (this.optsEl) this.optsEl.hidden = !showOpts;
      this.updateSummary(mixed);
      this.updateOptClasses();
      if (this.isRemoveSelected()) this.showPreview(); else this.clearPreview();
      this.applyGate();
    }
    applyGate() {
      const { pre } = this.totals();
      const unavailable = this.hasUnavailableBundle();
      // If the customer chose "Remove the pre-order items", the pack-min lines are dropped at
      // checkout — so their quantity being a non-multiple no longer matters (don't block on it).
      const badPack = this.hasInvalidPackLine() && !this.isRemoveSelected();
      if (this.unavailableMsg) this.unavailableMsg.hidden = !unavailable;
      if (this.packminMsg) this.packminMsg.hidden = !badPack;
      // Block checkout if a pre-order isn't acknowledged, an unavailable bundle is present, or a
      // pack-min pre-order line isn't a whole-pack multiple.
      const block = (pre > 0 && !this.acknowledged()) || unavailable || badPack;
      this.checkoutBtns().forEach((btn) => {
        btn.disabled = block;
        btn.setAttribute('aria-disabled', String(block));
      });
    }
  }
  customElements.define('so-preorder-cart', SoPreorderCart);
})();
